import {
  SET_TRIAL_INFO,
  SET_PLOTTR_LICENSE_INFO,
  SET_PRO_LICENSE_INFO,
  SET_LICENSE_CHECK_INTERVAL_ID,
  RECONNECTED_TO_LICENSING_API,
  SET_PRE_PRODUCTION,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').PlottrLicense} PlottrLicense
 * @typedef {import('../types/system').ProLicense} ProLicense
 * @typedef {import('../types/system').TrialInfo} TrialInfo
 */

/**
 * @typedef {ReturnType<typeof setTrialInfo> | ReturnType<typeof setPlottrLicenseInfo> | ReturnType<typeof setProLicenseInfo> | ReturnType<typeof setLicenseCheckIntervalId> | ReturnType<typeof reconnectedToLicensingApi> | ReturnType<typeof setPreProduction>} LicenseActions
 */

/**
 * @param {TrialInfo | Null} trialInfo
 * @return {{ type: 'SET_TRIAL_INFO', trialInfo: TrialInfo | Null, now: Date }}
 */
export const setTrialInfo = (trialInfo) => ({
  type: SET_TRIAL_INFO,
  trialInfo,
  now: new Date(),
})

/**
 * @param {PlottrLicense | Null} licenseInfo
 * @return {{ type: 'SET_PLOTTR_LICENSE_INFO', licenseInfo: PlottrLicense | Null, now: Date }}
 */
export const setPlottrLicenseInfo = (licenseInfo) => ({
  type: SET_PLOTTR_LICENSE_INFO,
  licenseInfo,
  now: new Date(),
})

/**
 * @param {ProLicense | Null} licenseInfo
 * @return {{ type: 'SET_PRO_LICENSE_INFO', licenseInfo: ProLicense | Null, now: Date }}
 */
export const setProLicenseInfo = (licenseInfo) => ({
  type: SET_PRO_LICENSE_INFO,
  licenseInfo,
  now: new Date(),
})

/**
 * @param {ReturnType<typeof setInterval>} intervalId
 * @return {{ type: 'SET_LICENSE_CHECK_INTERVAL_ID', intervalId: ReturnType<typeof setInterval> }}
 */
export const setLicenseCheckIntervalId = (intervalId) => {
  return {
    type: SET_LICENSE_CHECK_INTERVAL_ID,
    intervalId,
  }
}

/**
 * @return {{ type: 'RECONNECTED_TO_LICENSING_API' }}
 */
export const reconnectedToLicensingApi = () => {
  return {
    type: RECONNECTED_TO_LICENSING_API,
  }
}

/**
 * @return {{ type: 'SET_PRE_PRODUCTION' }}
 */
export const setPreProduction = () => {
  return {
    type: SET_PRE_PRODUCTION,
  }
}
